export const GANGSHEET_LAMBDA_URL = 'https://itkyvtftbqpf65klkp22nhezne0rrcqg.lambda-url.us-west-1.on.aws/';
export const PREFERD_GANGSHEET_LAMBDA_URL = 'https://bfyae664jfnldvddblc4v4yenq0whcgh.lambda-url.us-west-1.on.aws/';
export const CREATE_IMAGES_LAMBDA_URL = 'https://tegqf2v4wh2prvook7tjr2zoia0ixwfn.lambda-url.us-west-1.on.aws/';
export const PREFERD_SHEET_LAMBDA_URL = 'https://sgfmjnkh3dlkzpgcn7nw5f7ug40xctaf.lambda-url.us-west-1.on.aws/';
export const S3_BASE_URL = 'https://new-auto-builder.s3.us-west-1.amazonaws.com/';
export const BATCH_SIZE = 10;
export const UPLOAD_CONCURRENCY = 4;

// export const GANGSHEET_LAMBDA_URL = 'http://localhost:3000/dev/createGangsheet';
// export const PREFERD_GANGSHEET_LAMBDA_URL = 'http://localhost:3000/dev/createPreferdGangsheet';
// export const CREATE_IMAGES_LAMBDA_URL = 'http://localhost:3000/dev/createImages';
// export const PREFERD_SHEET_LAMBDA_URL = 'http://localhost:3000/dev/preferdSheet';